import { render, staticRenderFns } from "./ElraReport8Orientations.vue?vue&type=template&id=d773c358&scoped=true"
import script from "./ElraReport8Orientations.vue?vue&type=script&lang=ts"
export * from "./ElraReport8Orientations.vue?vue&type=script&lang=ts"
import style0 from "./ElraReport8Orientations.vue?vue&type=style&index=0&id=d773c358&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d773c358",
  null
  
)

export default component.exports